import React from 'react';

const BenefitsCards = () => {
    return (
        <section className="benefits-section py-10 lg:py-20 bg-holborn-app-blue">
            <div className="container mx-auto px-4">
                <div className="mb-10">
                    <h2 className="text-2xl lg:text-4xl font-bold lg:w-1/2">Why Holborn are the financial services group of choice.</h2>                
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-holborn-mid-blue">
                    <div className="card benefits-card flex flex-col p-6 bg-white rounded-2xl">
                        <h3 className="benefits-card-title text-4xl font-bold">$2bn+</h3>
                        <p className="benefits-card-text text-lg">assets under management</p>
                    </div>
                    <div className="card benefits-card flex flex-col p-6 bg-white rounded-2xl">
                        <h3 className="benefits-card-title text-4xl font-bold">20,000+</h3>
                        <p className="benefits-card-text text-lg">clients around the world</p>
                    </div>
                    <div className="card benefits-card flex flex-col p-6 bg-white rounded-2xl">
                        <h3 className="benefits-card-title text-4xl font-bold">18</h3>
                        <p className="benefits-card-text text-lg">international offices</p>
                    </div>
                    <div className="card benefits-card flex flex-col p-6 bg-white rounded-2xl">
                        <h3 className="benefits-card-title text-4xl font-bold">500+</h3>
                        <p className="benefits-card-text text-lg">members of staff</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BenefitsCards;